import React from 'react'

export const OpenKodiSidebarIcon = ({ size = 21, color = 'currentColor' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7.875 3.5V17.5M12.25 8.75L14 10.5L12.25 12.25M3.5 5.25C3.5 4.78587 3.68437 4.34075 4.01256 4.01256C4.34075 3.68437 4.78587 3.5 5.25 3.5H15.75C16.2141 3.5 16.6592 3.68437 16.9874 4.01256C17.3156 4.34075 17.5 4.78587 17.5 5.25V15.75C17.5 16.2141 17.3156 16.6592 16.9874 16.9874C16.6592 17.3156 16.2141 17.5 15.75 17.5H5.25C4.78587 17.5 4.34075 17.3156 4.01256 16.9874C3.68437 16.6592 3.5 16.2141 3.5 15.75V5.25Z"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
